export default __webpack_public_path__ + "static/media/Monk's Girdle of the Eighteen Pits.985f7052.jpg";